(function(){
  'use strict';
  function parseItalian(value){
    const m=String(value||'').trim().match(/^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})$/);
    if(!m)return null;
    // Faber Days 2026 occurs while Italy is UTC+2.
    return Date.UTC(+m[1],+m[2]-1,+m[3],+m[4]-2,+m[5]);
  }
  function active(el){
    const mode=(el.dataset.rpdFaberDaysMode||'off').toLowerCase();
    if(mode==='on')return true;
    if(mode!=='schedule')return false;
    const start=parseItalian(el.dataset.rpdFaberDaysStart);
    const end=parseItalian(el.dataset.rpdFaberDaysEnd);
    if(start===null||end===null||end<=start)return false;
    const now=Date.now();
    return now>=start&&now<end;
  }
  function money(cents,format){
    const value=(Number(cents||0)/100).toFixed(2).replace('.',',');
    const f=String(format||'€{{amount_with_comma_separator}}');
    return f.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g,value)
            .replace(/\{\{\s*amount\s*\}\}/g,(Number(cents||0)/100).toFixed(2));
  }
  function sync(){
    document.querySelectorAll('[data-rpd-faber-days-card]').forEach(el=>{
      const eligible=el.dataset.rpdFaberDaysEligible==='true';
      const promo=el.querySelector('[data-rpd-faber-days-promo-price]');
      const normal=el.querySelector('[data-rpd-faber-days-normal-price]');
      if(!promo||!normal)return;
      const on=eligible&&active(el);
      promo.hidden=!on;
      normal.hidden=on;
      if(!on)return;
      const base=Number(el.dataset.rpdFaberDaysBaseCents||0);
      const discount=Number(el.dataset.rpdFaberDaysDiscountCents||0);
      const fmt=el.dataset.rpdFaberDaysMoneyFormat||'';
      const original=promo.querySelector('[data-rpd-faber-days-original]');
      const final=promo.querySelector('[data-rpd-faber-days-final]');
      if(original)original.textContent=money(base,fmt);
      if(final)final.textContent=money(Math.max(0,base-discount),fmt);
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',sync);
  else sync();
  document.addEventListener('shopify:section:load',sync);
})();